import { useState } from "react";
import AIVideoEditorContext from "./aiVideoEditorContext";
import ViewService from "services/ViewService";

function AIVideoEditorProvider({ children }) {
    const [markerLeft, setMarkerLeft] = useState(0);
    const [currentTimeSec, setCurrentTimeSec] = useState(0);
    const [aiVideoShootsStates, setAiVideoShootsStates] = useState({
        job_id: null,
        images: [],
        videos: [],
        selectedTemplate: null,
        templateDuration: 0,
        available_fonts: [],
        global_background: null,
        global_text_Configuration: {
            font: null,
            font_style: null,
            font_size: 24,
            color: "#ffffff",
            shadow: false,
        },
        avatars: [],
        avatarDraft: null,
        musics: [],
        brandings: [],
        scripts: [],
        scriptGlobalSubtitle: false,
        texts: [],
        elements: [],
        brolls: [],
        canvas: [],
        shapes: [],
        globalPlatform: "bytedance"
    })
    const [showGenericToast, setShowGenericToast] = useState({
        status: false,
        type: "success",
        message: "",
    });
    const [currentItemKey, setCurrentItemKey] = useState("media");
    const [zoomLevel, setZoomLevel] = useState(1);
    const [currentSelectedScriptId, setCurrentSelectedScriptId] = useState(null);
    const [avatarSwitchMode, setAvatarSwitchMode] = useState("creatify");
    const [creditsStates, setCreditsStates] = useState({
        loading: false,
        credits: 0
    })

    const handleResetVideoTime = () => {
        setMarkerLeft(0);
        setCurrentTimeSec(0);
    }

    const fetchCredits = async () => {
        try {
            setCreditsStates({
                ...creditsStates,
                loading: true
            });
            const response = await ViewService.getStudioAICredits();
            setCreditsStates({
                ...creditsStates,
                loading: false,
                credits: response?.data?.credits
            })
        } catch (error) {
            setCreditsStates({
                ...creditsStates,
                loading: false,
                credits: 0
            })
        }
    };

    const handleResetAIVideoShootStates = () => {
        setAiVideoShootsStates({
            job_id: null,
            images: [],
            videos: [],
            selectedTemplate: null,
            templateDuration: 0,
            available_fonts: [],
            global_background: null,
            global_text_Configuration: {
                font: null,
                font_style: null,
                font_size: 24,
                color: "#ffffff",
                shadow: false,
            },
            avatars: [],
            avatarDraft: null,
            musics: [],
            brandings: [],
            scripts: [],
            scriptGlobalSubtitle: false,
            texts: [],
            elements: [],
            brolls: [],
            canvas: [],
            shapes: [],
            globalPlatform: "bytedance"
        })
        setCurrentItemKey("media");
        setZoomLevel(1);
        setCurrentSelectedScriptId(null);
        setShowGenericToast({
            status: false,
            type: "success",
            message: ""
        })
    }

    const deselectAllOverlays = () => {
        setAiVideoShootsStates((prev) => ({
            ...prev,
            texts: prev?.texts?.map((textData) => {
                return {
                    ...textData,
                    isSelected: false
                }
            }),
            elements: prev?.elements?.map((elementData) => {
                return {
                    ...elementData,
                    isSelected: false
                }
            }),
            brolls: prev?.brolls?.map((brollData) => {
                return {
                    ...brollData,
                    isSelected: false
                }
            }),
            shapes: prev?.shapes?.map((shapeData) => {
                return {
                    ...shapeData,
                    isSelected: false
                }
            }),
            canvas: prev?.canvas?.map((canvasData) => {
                if (canvasData?.hasFrame) {
                    return {
                        ...canvasData,
                        frame: {
                            ...canvasData?.frame,
                            isSelected: false
                        }
                    }
                }
                else {
                    return canvasData
                }
            })
        }))
    }

    const deselectAllOverlaysDIY = ()=>{
        setAiVideoShootsStates((prev)=>{
            let updatedOverlaysData = {};
            for(let overlayKey of Object.keys(prev?.diy?.overlays)){
                const updatedData = prev?.diy?.overlays[overlayKey]?.data?.map((overlayRow)=>{
                    const updatedRowData = overlayRow?.data?.map((overlayData)=>{
                        return {
                            ...overlayData,
                            isSelected: false
                        }
                    })
                    return {
                        ...overlayRow,
                        isSelected: false,
                        data: updatedRowData
                    }
                })
                updatedOverlaysData[overlayKey] = {
                    ...prev?.diy?.overlays[overlayKey],
                    isSelected: false,
                    data: updatedData
                }
            }
            return {
                ...prev,
                diy: {
                    ...prev?.diy,
                    overlays: {
                        ...updatedOverlaysData
                    }
                }
            }
        })
    }
    return (
        <AIVideoEditorContext.Provider value={{ markerLeft, setMarkerLeft, currentTimeSec, setCurrentTimeSec, handleResetVideoTime, aiVideoShootsStates, setAiVideoShootsStates, handleResetAIVideoShootStates, showGenericToast, setShowGenericToast, deselectAllOverlays, currentItemKey, setCurrentItemKey, zoomLevel, setZoomLevel, currentSelectedScriptId, setCurrentSelectedScriptId, avatarSwitchMode, setAvatarSwitchMode, fetchCredits, creditsStates, deselectAllOverlaysDIY }}>
            {children}
        </AIVideoEditorContext.Provider>
    );
}

export default AIVideoEditorProvider